import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuDetailsTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);

  const getCellData = (key, index) => {
    if (!data || !data[index]) {
      return 'N/A';
    }

    if (!data[index].oocyteEmbryo) {
      return 'N/A';
    }

    if (key === 'vitrifiedOocytes') {
      const day6 = data[index].oocyteEmbryo.day6.data;
      let count = 0;
      for (let i = 0; i < day6.length; i++) {
        if (day6[i].fate === 'Cryopreserve') {
          count++;
        }
      }
      return count;
    }

    if (
      !data[index].summary ||
      data[index].summary[key] === null ||
      data[index].summary[key] === ''
    ) {
      return 'N/A';
    }

    if (key === 'oocyteQuality' || key === 'spermQuality') {
      if (
        !data[index].summary[key] ||
        data[index].summary[key] === '' ||
        data[index].summary[key] === ' '
      ) {
        return 'N/A';
      }
      if (data[index].summary[key] === 'Good') {
        return '3';
      } else if (data[index].summary[key] === 'Moderate') {
        return '2';
      } else if (data[index].summary[key] === 'Poor') {
        return '1';
      } else {
        return 'N/A';
      }
    }

    if (key === 'date') {
      return data[index].summary[key]
        ? new Date(data[index].summary[key]).toLocaleDateString('en-uk')
        : 'N/A';
    }

    if (key === 'methodOfFertilization') {
      const method = data[index].summary[key];
      let methods = '';
      for (let i = 0; i < method.length; i++) {
        if (method[i].checked) {
          if (methods === '') {
            methods = method[i].name;
          } else {
            methods = methods + ', ' + method[i].name;
          }
        }
      }

      return methods === '' ? 'N/A' : methods;
    }

    return data[index].summary[key] ?? 'N/A';
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={8}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            OPU DETAILS {'<'}"0"
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>Date of OPU</TableCell>
          <TableCell style={{ fontWeight: 700 }}>AMH Levels</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Expected Follicles</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Retrieved OCC</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            No. of Vitrified Oocytes
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>Quality of Oocyte</TableCell>
          <TableCell style={{ fontWeight: 700 }}>Quality of Sperm</TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            Fertilisation Procedure (IVF/ICSI/PICSI/OTHER)
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={8}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>

        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('date', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('amhLevels', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('expectedFollicles', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('retrievedOCC', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('vitrifiedOocytes', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('oocyteQuality', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('spermQuality', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('methodOfFertilization', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuDetailsTable;
